import script from "./ExamPurchase.vue?vue&type=script&setup=true&lang=ts"
export * from "./ExamPurchase.vue?vue&type=script&setup=true&lang=ts"

import "./ExamPurchase.vue?vue&type=style&index=0&id=b7b8038e&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-b7b8038e"]])

export default __exports__